import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { Edge } from 'src/app/geometrics-form/edges/state/edge.model';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';
import { edgeToFeature } from '../mappers/geojon-mapper';
import { Plotter } from './plotter';
import { FeatureOpenService } from '../actions/layer-actions/feature-open.service';
import { EdgeFormComponent } from 'src/app/geometrics-form/edges/edge-form/edge-form.component';
import { MapService } from 'src/app/shared/components/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class EdgePlotter extends Plotter<Edge> {

  type: GeometricFormType = 'mitra-edge';
  mapper = edgeToFeature;

  constructor(
    protected mapService: MapService,
    protected openService: FeatureOpenService,
  ) {
    super([]);

    mapService.map$.subscribe(m => {
      this.init(m);
      this.openService.listen(
        m,
        {
          title: $localize`EDIT EDGE`,
          layerName: this.type,
          componentType: EdgeFormComponent
        }
      );
    });
  }

  layer: mapboxgl.Layer = {
    id: this.type,
    type: 'line',
    source: this.type,
    paint: {
      'line-color': [
        'match',
        ['get', 'map_legend'],
        'A', '#3effe8',
        'U', '#f0ad4e',
        'L', '#5cb85c',
        '#ff0000'
      ],
      'line-width': 5,
      'line-opacity':
        ['case',
          [
            'boolean',
            ['feature-state', 'm_hover'],
            false
          ],
          1,
          0.7
        ],
      'line-dasharray': [2, 1]
    }
  };

}
